module.exports = __webpack_public_path__ + "img/weask_logo.eee5ca8d.svg";